import { useMemo } from 'react';

import type { TagAssignment } from '~/services/TagsService';

import type { AssignmentFormData } from '../TagAssignments/TagAssignments';

import { useGetTagAssignments } from './useTagAssignments';

interface UseTagAssignmentsForFormParams {
  tagId?: string;
}

interface UseTagAssignmentsForFormReturn {
  assignments: Array<AssignmentFormData>;
  savedAssignments: Array<TagAssignment>;
  isLoading: boolean;
}

export function useTagAssignmentsForForm({ tagId }: UseTagAssignmentsForFormParams): UseTagAssignmentsForFormReturn {
  const { data = null, isLoading } = useGetTagAssignments(
    tagId
      ? {
          tagId,
          offset: 0,
          limit: 300,
        }
      : undefined,
    !!tagId,
  );

  const savedAssignments: Array<TagAssignment> = useMemo(() => data?.result || [], [data?.result]);

  const assignments: Array<AssignmentFormData> = useMemo(() => {
    return savedAssignments.map((assignment) => ({
      entityType: assignment.entityType as AssignmentFormData['entityType'],
      entityId: assignment.entityId,
    }));
  }, [savedAssignments]);

  return {
    assignments,
    savedAssignments,
    isLoading,
  };
}
